const state = {
  canvasTemplates: [],
  multipleCopies: [],
  itemCategory: "",
  itemSubCategory: "",
  simpleType: true,
  itemTypeSelectOptions: [],
  itemSuperCategoryId: "",
  itemMainCategoryId: "",
  itemType: "",
  itemId: "",
  itemName: "",
  itemCopiesSelectOptions: [],
  itemCopies: 0,
  itemPrice: 0,
  itemFullPrice: 0,
  selectedTypeArray: "",
  showItemTypeSelectionArray: [],
  sendExtraEmailOnOrder: "",
  allowTemplateClones: false,
  allowCustomSize: false,
  minTemplateClones: 0,
  maxTemplateClones: 0,
  enableDeviceBasedEdit: false,
  currentImagePreview: {},
  iIndex: 0,
  cIndexMode: "",
  customSizeWidth: 0,
  customSizeHeight: 0,
  maxCustomSizeHeight: 0,
  maxCustomSizeWidth: 0,
  overrideSize: false,
  overrideSizeWidth: 0,
  overrideSizeHeight: 0,
  itemGiftCardCode: "",
  itemGiftCardValidTo: new Date(),
  validTo: 0, // za darilne bone
  skipEdit: false, // za darilne bone in navadne izdelke
  superType: 1, // default foto izdelek
};

const getters = {};

const actions = {
};

const mutations = {
  SET_OVERRIDE_SIZE(state, payload) {
    state.overrideSize = payload;
  },
  SET_OVERRIDE_SIZE_WIDTH(state, payload) {
    state.overrideSizeWidth = payload;
  },
  SET_OVERRIDE_SIZE_HEIGHT(state, payload) {
    state.overrideSizeHeight = payload;
  },
  SET_SHOW_ITEM_TYPE_SELECTION_ARRAY(state, payload) {
    state.showItemTypeSelectionArray = payload;
  },
  SET_SEND_EXTRA_EMAIL_ON_ORDER(state, payload) {
    state.sendExtraEmailOnOrder = payload;
  },
  SET_ALLOW_TEMPLATE_CLONES(state, payload) {
    state.allowTemplateClones = payload;
  },
  SET_ALLOW_CUSTOM_SIZE(state, payload) {
    state.allowCustomSize = payload;
  },
  SET_SUPER_TYPE(state, payload) {
    state.superType = payload;
  },
  SET_MIN_TEMPLATE_CLONES(state, payload) {
    state.minTemplateClones = payload;
  },
  SET_MAX_TEMPLATE_CLONES(state, payload) {
    state.maxTemplateClones = payload;
  },
  SET_ENABLE_DEVICE_BASED_EDIT(state, payload) {
    state.enableDeviceBasedEdit = payload;
  },
  SET_ITEM_CATEGORY(state, payload) {
    state.itemCategory = payload;
  },
  SET_ITEM_SUPER_CATEGORY_ID(state, payload) {
    state.itemSuperCategoryId = payload;
  },
  SET_ITEM_MAIN_CATEGORY_ID(state, payload) {
    state.itemMainCategoryId = payload;
  },
  SET_CANVAS_TEMPLATES(state, payload) {
    state.canvasTemplates = payload;
  },
  SET_ITEM_NAME(state, payload) {
    state.itemName = payload;
  },
  SET_ITEM_SUB_CATEGORY(state, payload) {
    state.itemSubCategory = payload;
  },
  SET_SIMPLE_TYPE(state, payload) {
    state.simpleType = payload;
  },
  SET_ITEM_TYPE_SELECT_OPTIONS(state, payload) {
    state.itemTypeSelectOptions = payload;
  },
  SET_ITEM_TYPE(state, payload) {
    state.itemType = payload;
  },
  SET_ITEM_COPIES(state, payload) {
    state.itemCopies = payload;
  },
  SET_ITEM_ID(state, payload) {
    state.itemId = payload;
  },
  SET_ITEM_COPIES_SELECT_OPTIONS(state, payload) {
    state.itemCopiesSelectOptions = payload;
  },
  SET_ITEM_PRICE(state, payload) {
    state.itemPrice = payload;
  },
  SET_ITEM_FULL_PRICE(state, payload) {
    state.itemFullPrice = payload;
  },
  SET_SELECTED_TYPE_ARRAY(state, payload) {
    state.selectedTypeArray = payload;
  },
  SET_VALID_TO(state, payload) {
    state.validTo = payload;
  },
  SET_SKIP_EDIT(state, payload) {
    state.skipEdit = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
